import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "29",
  height: "34",
  fill: "none",
  viewBox: "0 0 29 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24 11.333h3.111c.413 0 .808.17 1.1.474s.456.716.456 1.145v19.429c0 .43-.164.841-.456 1.145a1.53 1.53 0 0 1-1.1.474H2.222c-.412 0-.808-.17-1.1-.474a1.65 1.65 0 0 1-.455-1.145V12.952c0-.429.164-.84.455-1.145a1.53 1.53 0 0 1 1.1-.474h3.111V9.714c0-2.576.984-5.047 2.734-6.869S12.191 0 14.667 0s4.85 1.023 6.6 2.845S24 7.138 24 9.715zM13.111 23.852v3.672h3.111v-3.672a3.2 3.2 0 0 0 1.319-1.565 3.36 3.36 0 0 0 .13-2.078 3.25 3.25 0 0 0-1.11-1.73 3.03 3.03 0 0 0-1.894-.67c-.685 0-1.35.236-1.894.67a3.25 3.25 0 0 0-1.111 1.73 3.36 3.36 0 0 0 .13 2.078 3.2 3.2 0 0 0 1.32 1.565m7.778-12.519V9.714a6.61 6.61 0 0 0-1.822-4.58 6.1 6.1 0 0 0-4.4-1.896c-1.65 0-3.233.682-4.4 1.897a6.61 6.61 0 0 0-1.822 4.58v1.618z"
    }, null, -1)
  ])))
}
export default { render: render }